import { useNavigate } from "react-router-dom";

export default function PersonalityResultCard() {
  const navigate = useNavigate();
  const message = localStorage.getItem("quizMessage");
  const description = localStorage.getItem("quizDescription");
  return (
    <div className="w-full font-inter px-3 sm:px-4 md:px-6">
      <div className="w-full max-w-[1200px] xl:max-w-[1400px] 2xl:max-w-[1600px] mx-auto bg-white border border-gray-100 rounded-2xl shadow-sm p-4 sm:p-6 md:p-8">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-12 items-center lg:items-start">
          {/* LEFT CONTENT */}
          <div className="flex-1 w-full max-w-2xl xl:max-w-3xl">
            {/* Title */}
            <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold text-gray-900 text-center lg:text-left">
              Based on your Personality Quiz results,{" "}
              <span className="text-[#6B2D8D] font-bold">
                you're {message || "Stem explorer"} !
              </span>
            </h2>

            {/* Description */}
            <p className="mt-3 text-xs sm:text-sm md:text-base leading-relaxed max-w-xl lg:max-w-2xl text-gray-600 leading-relaxed text-center lg:text-left">
              {description ||
                "Your results suggest you have a strong aptitude for STEM fields that require creativity, problem-solving, and hands-on work. You likely enjoy working with your hands, building things, and finding practical solutions to challenges. Careers in engineering, architecture, design, or technology development may be a great fit for your skills and interests."}
            </p>

            {/* Timeline Includes */}
            <div className="mt-5 md:mt-6">
              <h3 className="font-semibold text-gray-900 mb-3 text-center lg:text-left">
                Your Premium Timeline Includes :
              </h3>

              <ul className="space-y-3 sm:space-y-4 text-xs sm:text-sm md:text-base text-gray-700">
                <li className="flex gap-2 items-start">
                  <img src="/star.png" alt="star" className="w-4 h-4 mt-1" />
                  <span>
                    Step-by-step plan to strengthen your STEM knowledge and
                    skills.
                  </span>
                </li>

                <li className="flex gap-2 items-start">
                  <img src="/star.png" alt="star" className="w-4 h-4 mt-1" />
                  <span>
                    Discover interdisciplinary opportunities and career paths.
                  </span>
                </li>

                <li className="flex gap-2 items-start">
                  <img src="/star.png" alt="star" className="w-4 h-4 mt-1" />
                  <span>Guidance from experienced STEM professionals.</span>
                </li>

                <li className="flex gap-2 items-start">
                  <img src="/star.png" alt="star" className="w-4 h-4 mt-1" />
                  <span>
                    Competitions, mini-projects, and challenges to showcase your
                    skills.
                  </span>
                </li>
              </ul>
            </div>

            {/* Why it matters */}
            <div className="mt-5 md:mt-6">
              <h3 className="font-semibold text-gray-900 mb-2 text-center lg:text-left">
                Why It Matters :
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 text-center lg:text-left">
                Following this roadmap helps you gain confidence, unlock
                scholarships, internships, and career opportunities, and make a
                meaningful impact in the world.
              </p>
            </div>

            {/* Buttons */}
            <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center lg:justify-start items-stretch sm:items-center">
              <button
                onClick={() => navigate("/sap/select-timeline")}
                className="w-full sm:w-auto bg-[#572575] hover:bg-[#5A2576] text-white text-xs sm:text-sm font-medium px-6 py-2.5 rounded-lg transition flex items-center justify-center gap-2"
              >
                ⚙️ Get customized Timeline
              </button>

              <button
                onClick={() => navigate("/sap/other-career-interest")}
                className="w-full sm:w-auto border border-[#6B2D8D] text-[#6B2D8D] hover:bg-[#F6EDFA] text-xs sm:text-sm font-medium px-5 py-2 rounded-lg transition"
              >
                Explore Other Career Interest
              </button>
            </div>
          </div>

          {/* RIGHT ILLUSTRATION */}
          <div className="flex-shrink-0 w-full sm:w-[260px] md:w-[300px] lg:w-[340px] xl:w-[380px]">
            <img
              src="/Pa.png"
              alt="STEM Explorer Illustration"
              className="w-full h-auto object-contain max-w-[260px] sm:max-w-sm md:max-w-full mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
